import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  rootTwo: {
    "& > *": {
      margin: theme.spacing(1),
    },
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50%",
      textAlign: "right",
      float: "right",
      right: "0",
      marginLeft: "42%",
      marginBottom: "-136px",
    },
  },
  buttonSpace: {
    marginTop: "1rem",
    [theme.breakpoints.down("md")]: {
      textAlign: "right",
    },
  },
  hero: {
    height: "100%",
  },
  // heroContainer: {
  //   backgroundImage: 'url(../../assets/images/sample-banner1.png)',
  //   height: '780px',
  //   marginTop: '79px',
  //   backgroundRepeat: 'no-repeat',
  //   backgroundSize: 'cover',
  //   backgroundPosition: 'center',
  //   backgroundAttachment: 'fixed',
  //   display: 'flex',
  //   flexDirection: 'row',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   boxShadow: '0 3px 6px rgb(0 0 0 / 16%)',

  // },
  headerTitle: {
    fontSize: "40px",
    fontFamily: "Gilroy-ExtraBold, serif",
    marginBottom: "20px",
    [theme.breakpoints.down("md")]: {
      fontSize: "30px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "25px",
      marginTop: "30px",
    },
  },
  titlePara: {
    fontFamily: "Gilroy-Light, serif",
    lineHeight: "25px",
    fontSize: "18px",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "16px",
    },
  },
  container: {
    maxWidth: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 3px 6px rgb(0 0 0 / 16%)",
    [theme.breakpoints.down("md")]: {
      padding: "0",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0",
    },
  },
  gapOne: {
    marginBottom: "100px",
    [theme.breakpoints.down("md")]: {
      marginBottom: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: "0px",
      textAlign: "center",
    },
  },
  gapTwo: {
    marginTop: "20%",
    [theme.breakpoints.down("md")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "0px",
      textAlign: "center",
    },
  },
  left: {
    textAlign: "right",
    paddingLeft: "48px",
    alignItems: "flex-end",
    display: "flex",
    marginBottom: "100px",
    [theme.breakpoints.down("xs")]: {
      padding: "15px",
      marginBottom: "0px",
      textAlign: "center",
      backgroundColor: "#fff",
    },
  },

  right: {
    textRlign: "left",
    paddingRight: "48px",
    [theme.breakpoints.down("xs")]: {
      padding: "25px 15px",
      textAlign: "center",
    },
  },
  subTitle: {
    fontSize: "25px",
    fontFamily: "Gilroy-Light, serif",
    color: "#D62828",
    marginBottom: "35px",
    [theme.breakpoints.down("md")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
    },
  },
  subPara: {
    fontSize: "18px",
    fontFamily: "Gilroy-Light, serif",
    color: "#000",
    marginBottom: "35px",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
  button: {
    borderRadius: "20px",
    border: "2px solid #000",
    textTransform: "capitalize",
    width: 140,
    [theme.breakpoints.up("md")]: {
      width: 130,
      marginLeft: "5.5rem",
    },
    [theme.breakpoints.up("md")]: {
      width: 140,
      marginLeft: "0",
    },
    [theme.breakpoints.down("xs")]: {
      width: 130,
    },
  },
  AppButton: {
    marginTop: "2.5rem",
    width: "180px",
    height: "50px",
    borderRadius: "50px",
    fontSize: "1rem",
    color: "#e45826",
    border: "2px solid #e45826",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  info: {
    fontFamily: "Gilroy-Light, serif",
    padding: "0",
    backgroundColor: "#fffaf7",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "10%",
      paddingRight: "10%",
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: "3%",
      paddingRight: "3%",
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "10%",
      paddingRight: "10%",
    },
    [theme.breakpoints.up("xl")]: {
      paddingLeft: "20%",
      paddingRight: "20%",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "3%",
      paddingRight: "3%",
    },
  },
}));
